var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container",attrs:{"id":"mainpage"}},[_c('hero-start'),_c('article',[_c('idea'),_c('parallaxImages',{staticClass:"desktop-only"}),_c('imageGrid',{staticClass:"mobile-only"})],1),_c('stripe-banner'),_c('shop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }